export const SEGMENTS = [
  { key: "FULL_GAME", label: "Full Game" },
  { key: "FIRST_FIVE", label: "First 5" },
  { key: "FIRST_INNING", label: "First Inning" },
];
